import { render } from "./DialogCloneDistribution.vue?vue&type=template&id=778d4563"
import script from "./DialogCloneDistribution.vue?vue&type=script&lang=js"
export * from "./DialogCloneDistribution.vue?vue&type=script&lang=js"

import "./DialogCloneDistribution.vue?vue&type=style&index=0&id=778d4563&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__